import { useContext } from 'react';
import type { FC } from 'react';
import type { LocaldataProps } from 'react-localdata';
import { LocaldataContext } from 'react-localdata';
import classnames from 'classnames';

import OddValue from 'app/components/OddValue';
import type { MatchPreviewData, MatchPreviewTeam } from 'app/components/MatchPreview/types';
import warningIcon from 'app/icons/warning_empty.svg';
import Icon from 'app/components/Icon';

import style from './style.scss';

interface Props {
  match: Pick<
    MatchPreviewData,
    'markets_status' | 'competitors' | 'status' | 'id' | 'winner_market'
  >;
  teams: [MatchPreviewTeam, MatchPreviewTeam];
  monospace?: boolean;
  noOverround?: boolean;
  containerClassName?: string;
  valueClassName?: string;
  downStatus?: boolean;
}

const containerClassNameMap = {
  active: undefined,
  deactivated: style.container_deactivated,
  suspended: style.container_suspended,
  settled: undefined,
  pre_settled: undefined
};

const Winner3WayOdds: FC<Props> = ({
  match,
  teams,
  monospace = false,
  containerClassName,
  valueClassName,
  downStatus = false,
  noOverround = false
}) => {
  const {
    localdata: { displayedMarketOnSchedule: displayedMarket }
  }: LocaldataProps<AppLocaldata> = useContext(LocaldataContext);

  const matchStatus = match.markets_status?.[displayedMarket];
  const containerStatusClassName = matchStatus ? containerClassNameMap[matchStatus] : undefined;

  return (
    <div className={classnames(style.container, containerStatusClassName, containerClassName)}>
      <div>
        {downStatus ? (
          <Icon
            className={classnames(style.oddValue, style.withBorder, style.errorIcon)}
            href={warningIcon}
          />
        ) : (
          <OddValue
            value={teams[0].markets?.winner?.proba}
            className={classnames(style.oddValue, style.withBorder, valueClassName)}
            increaseClassName={style.oddIndicator_increase}
            decreaseClassName={style.oddIndicator_decrease}
            monospace={monospace}
            noOverround={noOverround}
          />
        )}
        {/* @TODO: we disable winner 3way external provider for now because hashi does not handle it */}
        {/* <PrivateContent access={['pandascore']}>
          <>
            {displayCompetitors &&
              match.providers.length > 0 &&
              ['set_up', 'pre_match', 'live'].includes(match.status) && (
                <CompetitorsOddsValues
                  type="match"
                  className={style.competitorOddValue}
                  match={match}
                  team={teams[0]}
                  template={'winner-3-way'}
                />
              )}
          </>
        </PrivateContent> */}
      </div>
      <div>
        {downStatus ? (
          <Icon
            className={classnames(style.oddValue, style.withBorder, style.errorIcon)}
            href={warningIcon}
          />
        ) : (
          <OddValue
            value={match.winner_market.tie_proba}
            className={classnames(style.oddValue, style.withBorder, valueClassName)}
            increaseClassName={style.oddIndicator_increase}
            decreaseClassName={style.oddIndicator_decrease}
            monospace={monospace}
            noOverround={noOverround}
          />
        )}
        {/* @TODO: we disable winner 3way external provider for now because hashi does not handle it */}
        {/* <PrivateContent access={['pandascore']}>
          <>
            @TODO handle match 3 way
            {displayCompetitors &&
              match.providers.length > 0 &&
              ['set_up', 'pre_match', 'live'].includes(match.status) && (
                <CompetitorsOddsValues
                  className={style.competitorOddValue}
                  match={match}
                  type="match"
                  team={teams[1]}
                  template={'winner-3-way'}
                />
              )}
          </>
        </PrivateContent> */}
      </div>
      <div>
        {downStatus ? (
          <Icon className={classnames(style.oddValue, style.errorIcon)} href={warningIcon} />
        ) : (
          <OddValue
            value={teams[1].markets?.winner?.proba}
            className={classnames(style.oddValue, valueClassName)}
            increaseClassName={style.oddIndicator_increase}
            decreaseClassName={style.oddIndicator_decrease}
            monospace={monospace}
            noOverround={noOverround}
          />
        )}
        {/* @TODO: we disable winner 3way external provider for now because hashi does not handle it */}
        {/* <PrivateContent access={['pandascore']}>
          <>
            {displayCompetitors &&
              match.providers.length > 0 &&
              ['set_up', 'pre_match', 'live'].includes(match.status) && (
                <CompetitorsOddsValues
                  type="match"
                  className={style.competitorOddValue}
                  match={match}
                  team={teams[1]}
                  template={'winner-3-way'}
                />
              )}
          </>
        </PrivateContent> */}
      </div>
    </div>
  );
};

Winner3WayOdds.displayName = 'Winner3WayOdds';

export default Winner3WayOdds;
